import styled from "styled-components";
import * as Flex from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import * as Button from "../../../../../../../../common-deprecated/styles/lexus/Button";
import Icon from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

export const Header = styled(Flex.Row)`
    ${Button.Link} {
        margin-left: ${theme.space[2]}px;
    }
    ${Icon} {
        &::before {
            font-size: 1.6rem;
        }
    }

    html[dir="rtl"] & {
        ${Button.Link} {
            margin-left: 0;
            margin-right: ${theme.space[2]}px;
        }
    }
`;
